import { useDispatch, useSelector } from "react-redux";
import { setLoginModule } from "../store/userData/userDataSlice";

const PrivateRoute = ({ element }) => {
  const user = useSelector((state) => state.userdata.loggedIn);
  const isLoaded = useSelector((state) => state.userdata.isUserDataLoaded);
  const websiteColor = useSelector((state) => state?.onLoadData?.color);

  const dispatch = useDispatch();

  const openLoginModal = () => {
    dispatch(setLoginModule(true));
  };

  if (!isLoaded && !user) {
    return (
      <div className="min-h-[70vh] flex flex-col items-center justify-center bg-gray-100 px-4 text-center">
        <h2 className="text-2xl font-bold text-gray-800">You’re not logged in</h2>
        <p className="text-gray-600 mb-4">
          Please log in or sign up to access this page.
        </p>

        <div className="flex flex-row gap-4 flex-wrap justify-center">
          {/* ✅ Login (filled button) */}
          <div
            className="cursor-pointer flex h-10 sm:h-12 text-sm sm:text-base 2xl:text-xl font-bold leading-relaxed font-inter px-4 sm:px-7 py-2 rounded-lg text-white items-center justify-center shadow-md hover:opacity-90 active:scale-95 transition-all duration-200 whitespace-nowrap"
            style={{
              backgroundColor: websiteColor,
            }}
            onClick={openLoginModal}
          >
            Login
          </div>

          {/* ✅ Sign Up (outlined button) */}
          <div
            className="cursor-pointer flex h-10 sm:h-12 text-sm sm:text-base 2xl:text-xl font-bold leading-relaxed font-inter px-4 sm:px-7 py-2 rounded-lg border items-center justify-center shadow-sm hover:opacity-90 active:scale-95 transition-all duration-200 whitespace-nowrap"
            style={{
              borderColor: websiteColor,
              color: websiteColor,
            }}
            onClick={openLoginModal}
          >
            Sign Up
          </div>
        </div>

      </div>
    );
  }


  return <div className="mt-[1px]">{element}</div> ;
};

export default PrivateRoute;
